import { Injectable } from '@angular/core';
import { User } from 'src/app/entities/user.entity';
import { ModelService } from 'src/app/services/model.service';
import { ConfigService } from 'src/app/app.config';
import { BearerHttpService } from 'src/app/services/bearer-http.service';
import { map, retry, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as actionsHistory from 'src/app/store/history/history.actions';
import { LoginService } from 'src/app/login/login_service/login.service';

@Injectable({
	providedIn: 'root'
})
export class UserListService {
	public totalUsers = 0;
	public activeUsers = 0;
	public desactiveUsers = 0;
	public waitUsers = 0;
	public deleteUsers = 0;
	public userList: User[];

	constructor(
		private store: Store,
		private http: BearerHttpService,
		private loginService: LoginService,
		private modelService: ModelService) { }

	public getList2(): void {
		this.http.Get(ConfigService.REST_SERVER + '/api/user')
			.pipe(map((res: Response) => res["result"])
			).subscribe((res) => {
				this.userList = res;
				this.activeUsers = this.userList ? this.userList.filter(function (user) { return user.estado === '1'; }).length : 0;
				this.totalUsers = this.userList.length;
			});
	}

	// Método que pide usuarios por página. Ordenados por empresa, nombre, email...
	// state		: Filtro principal, solo puede devolver usuarios de un estado (0 = Desactivado, 1 = Activo, 2 = En espera, 3 = Borrado).
	// order		: Orden ascendente/desendente y columna principal del orden.
	// page			: Página actual.
	// itemsByPage	: Cantidad de registros por página, por defecto 10.
	// projects		: Cantidad de proyectos del usuario (opcional).
	public getCurrentList(state: string, order: {}, page: number, itemsByPage: number) { //: Observable<any> {
		return this.http.Post(ConfigService.REST_SERVER + '/api/userFilter', {
			"state": state,
			"order": order,
			"page": page,
			"itemsByPage": itemsByPage,
			"projects": (state === '3'),
		})
		.pipe(map((res: any) => {
			this.userList = res.result.userList;
			this.totalUsers = res.result.totalUsers;
			this.activeUsers = res.result.activeUsers;
			this.desactiveUsers = res.result.desactiveUsers;
			this.waitUsers = res.result.waitUsers;
			this.deleteUsers = res.result.deleteUsers;
		}))
		.subscribe(res => {});
	}

	public updateUser(userData: User): Observable<any> {
		return this.http.Put(ConfigService.REST_SERVER + '/api/user', userData)
			.pipe(map(res => { this.modelService.getUser().userUpdatedSignal.emit(true); }));
	}

	public validateUser(userData: User) { //: Observable<any> {
		this.http.Put(ConfigService.REST_SERVER + '/api/user/activate/' + userData['_id'], userData)
			.pipe(map((res: any) => {
				this.modelService.getUser().userChangeSignal.emit('');
			}))
			.subscribe(res => { });
	}

	public deactivateUser(userData: User) { //: Observable<any> {
		return this.http.Put(ConfigService.REST_SERVER + '/api/user/deactivate/' + userData['_id'], userData)
			.pipe(map((res: any) => {
				this.modelService.getUser().userChangeSignal.emit('');
			}))
			.subscribe(res => { });
	}

	// Envia los datos necesarios del proyecto abierto al historial.
	// id: identificador del proyecto.
	// title: título del proyecto.
	// editor: si es Esqiema o Satélite.
	// userData: el actual usuario loginado.
	public historyProjects(id: string, title: string, editor: string, userData: User): Observable<any> {
		return this.http.Put(ConfigService.REST_SERVER + '/api/user/historyProjects/' + id + '/' + title + '/' + editor, userData)
			.pipe(map((res: any) => {
				if (res) {
					this.store.dispatch(actionsHistory.update({ lastProjects: res.result.lastProjects }));
					this.modelService.getUser().getData().lastProjects = res.result.lastProjects;
				}
			}));
	}

	// Quita un proyectos del historial.
	// id: identificador del proyecto.
	// userData: el actual usuario loginado.
	public historyCleanProject(id: string, userData: User): Observable<any> {
		return this.http.Put(ConfigService.REST_SERVER + '/api/user/historyCleanProject/' + id, userData)
			.pipe(map((res: any) => {
				if (res) {
					this.store.dispatch(actionsHistory.update({ lastProjects: res.result.lastProjects }));
					this.modelService.getUser().getData().lastProjects = res.result.lastProjects;
				}
			}));
	}
}
